export default {
  name: 'MainIndex',
  components: {},
  data: function data() {
    return {
      adOrder: {},
      adOrders: [],
      show: false
    };
  },
  methods: {
    queryOrder: function queryOrder() {
      var _this = this;

      this.adOrders = null;
      var url = "/ad-server/specialorder/query";
      this.$axios.post(url, this.adOrder).then(function (resp) {
        _this.adOrders = resp.data.list;

        if (_this.adOrders == null || _this.adOrders.length == 0) {
          _this.show = true;
        } else {
          _this.show = false;
        }
      });
    }
  }
};